import React, { forwardRef } from "react";

const JourneyPlannerMap = (_, ref) => (
  <div style={{ height: "100%" }} ref={ref} />
);

export default forwardRef(JourneyPlannerMap);
